<template>
    <div class="page_news_mobile">
        <div class="group_41 flex-row">
            <div class="block_18 flex-col">

                <div
                        class="news_item_list flex-row justify-between"
                        v-for="(news, index) in newsList"
                        :key="index"
                        @click="goToDetail(news)"
                >
                    <div class="news_image flex-col"
                         :style="{ backgroundImage: `url(${news.pic})` }"
                    ></div>
                    <div class="section_3 flex-col">
                        <span class="news_title">{{ news.title }}</span>
                        <span class="news_time">{{ news.publishTime }}</span>
                    </div>
                </div>

                <!--分页-->
                <div class="box_14 flex-row">
                    <!-- 左箭头 -->
                    <div class="image-wrapper flex-col" :class="currentPage > 1 ? 'image-wrapper_2' : 'image-wrapper_1'"
                         @click="currentPage > 1 && prevPage()">
                        <img class="thumbnail_7" src="../../../assets/news/news_icon_arr1.png" />
                    </div>

                    <!-- 分页数字 -->
                    <template v-for="(page, index) in displayedPages">
                        <div
                                v-if="page === '...'"
                                :key="'ellipsis' + index"
                                class="text_28"
                        >...</div>
                        <div
                                v-else
                                :key="page"
                                class="text-wrapper_5 flex-col"
                                :class="{ 'active-page': page === currentPage }"
                                @click="goToPage(page)"
                        >
                            <span class="text_page">{{ page }}</span>
                        </div>
                    </template>

                    <!-- 右箭头 -->
                    <div class="image-wrapper flex-col" :class="currentPage < totalPages ? 'image-wrapper_2' : 'image-wrapper_1'"
                         @click="currentPage < totalPages && nextPage()">
                        <img class="thumbnail_8" src="../../../assets/news/news_icon_arr2.png" />
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
    import {formartDate} from "../../../common/testFun";

    export default {
        props: {
            type: {
                type: Number,
                default: 1 // 默认值为1，表示"康柏动态"
            }
        },
        data() {
            return {
                contactBanner: null,

                totalCount:0,
                selectedCategory: '康柏动态', // 默认选中"全部新闻"
                currentPage: 1,
                pageSize: 6, // 每页显示6条新闻
                maxVisiblePages: 3, // 最多显示5个页码
                newsList: [],
                selectIndex:1,
                hoverIndex:-1,
            };
        },
        computed: {
            bannerStyle() {
                return {
                    backgroundImage: `url(${this.contactBanner})`,
                };
            },
            //
            filteredNews() {
                if (this.selectedCategory === '全部') {
                    return this.newsList;
                }
                return this.newsList.filter(item => item.category === this.selectedCategory);
            },
            totalPages() {
                return Math.ceil(this.totalCount / this.pageSize);
            },
            paginatedNews() {
                const start = (this.currentPage - 1) * this.pageSize;
                const end = start + this.pageSize;
                return this.newsList.slice(start, end);
            },
            displayedPages() {
                const range = [];
                let start = Math.max(
                    1,
                    this.currentPage - Math.floor(this.maxVisiblePages / 2)
                );
                let end = Math.min(
                    this.totalPages,
                    start + this.maxVisiblePages - 1
                );

                if (end - start < this.maxVisiblePages - 1) {
                    start = Math.max(1, end - this.maxVisiblePages + 1);
                }

                // 添加首尾页码
                if (start > 1) {
                    range.push(1);
                    if (start > 2) range.push('...');
                }

                for (let i = start; i <= end; i++) {
                    range.push(i);
                }

                if (end < this.totalPages) {
                    if (end < this.totalPages - 1) range.push('...');
                    range.push(this.totalPages);
                }

                return range;
            }
        },
        mounted() {
            let mypage =  this.$route.query.page;
            if(mypage){
                this.pageNum = mypage;
            }
            this.getInfo();
        },
        watch: {
            // 监听type变化，当type变化时重新获取数据
            type(newVal) {
                this.currentPage = 1; // 重置页码
                this.getInfo();
            }
        },
        methods: {
            change(){
                this.isVisible = false;
            },
            showContact(){
                this.isVisible = true;
            },
            // 新增分类切换方法
            selectCategory(category,type) {
                let url = 'Information';
                if(type === null){
                    url = 'Information';
                }else if(type === 1){
                    url = 'dynamics';
                }else if(type === 2){
                    url = 'observation';
                }
                this.$router.push(url, () => {
                    // 导航完成后滚动到顶部
                    window.scrollTo(0, 0);
                }, (error) => {
                    // 可选：处理导航失败的情况
                    console.error('导航失败:', error);
                });
            },
            hoverIndexFun(index){
                this.hoverIndex = index;
                this.selectIndex = index;
            },
            offhoverIndexFun(index){
                if(this.selectedCategory== '全部'){
                    this.selectIndex = 0 ;
                }else if(this.selectedCategory== '康柏动态'){
                    this.selectIndex = 1 ;
                }else if(this.selectedCategory== '行业观察'){
                    this.selectIndex = 2 ;
                }

                this.hoverIndex = -1;
            },
            goToPage(page) {
                if (page === '...' || page === this.currentPage) return;
                this.currentPage = page;
                this.getInfo(); // 切换页码时重新获取数据
            },
            prevPage() {
                if (this.currentPage > 1) {
                    this.currentPage--;
                    this.getInfo();
                }
            },
            nextPage() {
                if (this.currentPage < this.totalPages) {
                    this.currentPage++;
                    this.getInfo();
                }
            },
            // 实现两种跳转方式
            goToDetail(item) {
                //this.$router.push({path:'/news2', query: {id: item.id}});
                const url = `/news?id=${encodeURIComponent(item.id)}`;
                this.$router.push(url, () => {
                    // 导航完成后滚动到顶部
                    window.scrollTo(0, 0);
                }, (error) => {
                    // 可选：处理导航失败的情况
                    console.error('导航失败:', error);
                });

            },
            goToMore(url) {
                // 新标签页打开方式
                window.open(url, '_blank');
            },
            getInfo(){
                this.newsList = [];
                let selectType =null;
                if(this.type == 0){
                    selectType =null;
                }else{
                    selectType =this.type;
                }
                let query ={code:'xwzx',pageNum:this.currentPage,pageSize:6,type: selectType};
                this.$HTTP.getNewsList(query).then(resp => {
                    if(resp.code == 200){
                        let data = resp.data;
                        let dataList =data.newPage.list;
                        this.newsList = dataList.map(item=>{
                            item.publishTime = formartDate(item.publishTime)
                            return item;
                        });
                        this.totalCount = data.newPage.total;
                    }
                });
            },
        }
    };
</script>

<style scoped lang="css"  >

    .page_news_mobile {
        width: 100%;
        overflow: hidden;
        min-height: 100vh;
        box-sizing: border-box;
        overflow-x: hidden;
        padding-top: 20px;
        box-sizing: border-box;
    }

    .flex-col {
        display: flex;
        flex-direction: column;
    }

    .justify-between {
        display: flex;
        justify-content: space-between;
    }
    .flex-col {
        display: flex;
        flex-direction: column;
    }

    /*****/
    .group_41 {
        width: 100%;
        display: flex;
        justify-content: center;
    }

    .block_18 {
        width: 100%;
        padding: 0 20px;
        box-sizing: border-box;
    }

    .justify-between {
        display: flex;
        justify-content: space-between;
    }

    .flex-row {
        display: flex;
        flex-direction: row;
    }

    .news_image {
        width: 180px;
        height: 106px;
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center;
    }

    .section_3 {
        background-color: rgba(249, 249, 251, 1);
        width: calc(100% - 180px);
        height: 107px;
    }

    .news_time {
        width: 90px;
        height: 22px;
        overflow-wrap: break-word;
        color: rgba(51, 51, 51, 1);
        font-size: 16px;
        text-align: left;
        white-space: nowrap;
        line-height: 22px;
        margin: 10px 0 0 25px;
    }

    .news_item_list {

        margin: 20px 0 0 0px;
        transition: all 0.3s ease;
        cursor: pointer;

        width: 100%;
        max-width: 1200px;
        margin: 20px auto 0;
    }

    .news_item_list:hover {
        box-shadow: 0 6px 16px rgba(0, 0, 0, 0.12);
        transform: translateY(-2px);
    }

    /* Hover时修改内容区背景 */
    .news_item_list:hover .section_3 {
        background-color: #fff !important;
    }

    /* Hover时标题颜色变化 */
    .news_item_list:hover .news_title {
        color: #008683 !important;
    }
    .news_item_list:hover .text_14 {
        color: #008683 !important;
    }


    .news_title {
        max-width: 775px;
        height: 60px;
        overflow-wrap: break-word;
        color: rgba(51, 51, 51, 1);
        font-size: 22px;
        text-align: left;
        line-height: 30px;
        margin: 10px 0 0 25px;
    }


    .box_14 {
        height: 136px;
        background: url(../../../assets/news/news_icon_arr5.png) 100% no-repeat;
        background-size: 100% 100%;
        justify-content: center !important;
        width: 100%;
        max-width: 1200px;
        margin: 36px auto;
        padding: 0 20px;
        box-sizing: border-box;

    }

    .image-wrapper {
        height: 56px;
        background-size: 100% 100%;
        width: 56px;

        margin: 40px 24px 0 24px !important;
        flex-shrink: 0;
        cursor: pointer;
        transition: all 0.3s ease;
    }


    /* 右箭头特定位置调整 */
    .image-wrapper:last-child {
        margin: 40px 514px 0 43px;
    }

    .image-wrapper_1 {
        height: 56px;
        background: url(../../../assets/news/news_icon_arr6.png)
        100% no-repeat;
        background-size: 100% 100%;
        width: 56px;

        opacity: 0.5;
        cursor: not-allowed;

    }

    .thumbnail_7 {
        width: 7px;
        height: 12px;
        margin: 22px 0 0 25px;
    }

    .text-wrapper_5 {
        height: 56px;
        background: url(../../../assets/news/news_icon_arr7.png)
        0px -1px no-repeat;
        background-size: 56px 57px;
        width: 56px;
        margin: 40px 0 0 10px;
    }

    .text_page {
        width: 7px;
        height: 22px;
        overflow-wrap: break-word;
        color: rgba(0, 134, 131, 1);
        font-size: 16px;
        text-align: left;
        white-space: nowrap;
        line-height: 22px;
        margin: 16px 0 0 25px;
    }
    /* 添加间距控制 */
    .flex-row {
        gap: 8px;
    }


    /* 当前页样式增强 */
    .active-page {
        background: rgba(0, 134, 131, 0.2);
        border-radius: 4px;
    }

    .text_28 {
        width: 13px;
        height: 22px;
        overflow-wrap: break-word;
        color: rgba(23, 23, 23, 1);
        font-size: 16px;
        text-align: left;
        white-space: nowrap;
        line-height: 22px;
        margin: 56px 0 0 44px;
    }

    .image-wrapper_2 {
        height: 56px;
        background: url(../../../assets/news/news_icon_arr4.png)
        100% no-repeat;
        background-size: 100% 100%;
        width: 56px;
        margin: 40px 514px 0 43px;
    }

    .thumbnail_8 {
        width: 7px;
        height: 12px;
        margin: 22px 0 0 26px;
    }


    /* 保持原有的PC样式 */
    .flex-col {
        display: flex;
        flex-direction: column;
    }

    @media (max-width: 600px) {
        .news_item_list {

        }
        .news_image {
            width: 100px;
            height: 60px;
        }
        .section_3 {
            height: 65px;
            width: calc(100% - 70px);
        }
        .news_title {
            font-size: 15px;
            line-height: 18px;
            margin: 5px 0 0 15px;
        }
        .news_time {
            font-size: 12px;
            line-height: 18px;
            color: #858587;
            margin: 5px 0 0 15px;
        }

        /**分页**/
        .box_14 {
            height: 72px;
        }
        .text-wrapper_5 {
            height: 36px;
            background-size: 37px 37px;
            width: 36px;
            margin: 20px 0 0 5px;
        }

        .image-wrapper_2 {
            height: 36px;
            width: 36px;
            margin: 20px 514px 0 5px;
        }
        .image-wrapper {
            height: 36px;
            width: 36px;
            margin: 20px 5px 0 5px !important;
        }
        .text_28 {
            width: 13px;
            height: 22px;
            margin: 20px 0 0 5px;
        }
        .thumbnail_7, .thumbnail_8 {
            margin: 12px 0 0 15px;
        }
        .text_page {
            margin: 8px 0 0 12px;
        }
    }

</style>
